import { Component, OnInit, ElementRef, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'dropdown-actions',
  templateUrl: './dropdown-actions.component.html',
  styleUrls: ['./dropdown-actions.component.scss'],
  host: { '(document:click)': 'onClick($event)' }
})
export class DropdownActionsComponent implements OnInit {

  // Inputs variables
  @Input() items: any;
  @Input() tooltipText: any;

  // Output variables
  @Output() onItemSelect: EventEmitter<any> = new EventEmitter<any>();

  // Public Variables
  public active: boolean = false;
  public itemsList: any;

  constructor(private _eref: ElementRef) { }

  ngOnInit() {
    this.itemsList = this.items;
  }

  // On Click Filter Icon
  public onClickArrow(): void {
    this.active = !this.active;
  }

  // On element click
  public onClick(event): void {
    if (!this._eref.nativeElement.contains(event.target) && this.active) this.active = false;
  }

  // On Click Item List
  public onClickItem(activity: any, group: any) {
    this.itemsList.list.filter(filter => {
      filter.items.filter(item => item.key === activity.key)
        .map(result => {
          result.value = !result.value;
          this.onItemSelect.emit(Object.assign(activity, { group: group }));
        });
      });
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/dropdown-actions/dropdown-actions.component.ts